import { render } from "./AddGroupeTaxeModal.vue?vue&type=template&id=05805e31&ts=true"
import script from "./AddGroupeTaxeModal.vue?vue&type=script&lang=ts"
export * from "./AddGroupeTaxeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__